import { MaybeElementRef, useMouseInElement } from "@vueuse/core";
import useIsTouch from '@/composables/useIsTouch';

const round = (n: number, decimals: number) => {
  const factor = 10 ** decimals;
  return Math.round(n * factor) / factor;
};

export default function useHoverTilt(target: MaybeElementRef) {
  const isTouch = useIsTouch();

  if (isTouch) return { tilt: computed(() => ({ x: 0, y: 0 })) };

  const { elementX, elementY, elementWidth, elementHeight, isOutside } = useMouseInElement(target, { handleOutside: false});

  // mouse 3d tilt effect with css
  const tilt = computed(() => {
    if (isOutside.value) return { x: 0, y: 0 };
    
    const amount = 30;
    const tiltY = round((elementY.value / elementHeight.value - 0.5) * amount, 0);
    const tiltX = round((elementX.value / elementWidth.value - 0.5) * amount, 0);
    
    return {
      x: -tiltY,
      y: tiltX,
    };
  });

  return { tilt };
}
